import React, { useState, use, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { ApiContext } from "../Context/Context";
import { Link } from "react-router-dom";

import LoginDialog from "./LoginDialog";

import {
  BaseUrl,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../Services/Urls";
import { useNavigate } from "react-router-dom";
import FilterParams from "../Classes/FilterParams";

function Header() {
  const { logindata, setlogindata, userData, setuserData } =
    useContext(ApiContext);
  const navigate = useNavigate();
  const [openLogin, setOpenLogin] = useState(false);
  const [loginType, setLoginType] = useState(null); // mobile | email

  useEffect(() => {
    if (LoggedInUserID == null && LoggedInUserName == null) {
      const storedLoginData = localStorage.getItem("loginData");
      const storedUserData = localStorage.getItem("UserData");
      if (storedLoginData && storedUserData) {
        const parsedData = JSON.parse(storedLoginData);
        const parsedUserData = JSON.parse(storedUserData);
        setlogindata(parsedData);
        setLogindata(parsedData);

        setUserdata(parsedUserData);
        setuserData(parsedUserData);
      }
    }
  }, []);

  const handleNavigate = () => {
    if (logindata && LoggedInUserID != null) {
      navigate("/post-property");
    } else {
      setOpenLogin(true);
    }
  };

  return (
    <>
      <header className="header-wrap">
        <div className="container">
          <nav className="navbar navbar-expand-md navbar-light">
            <Link className="navbar-brand" to="/">
              <img
                className="logo-light"
                src="assets/img/logo.svg"
                alt="logo"
              />
              <img className="logo-dark" src="assets/img/logo.svg" alt="logo" />
            </Link>
            <div
              className="collapse navbar-collapse main-menu-wrap"
              id="navbarSupportedContent"
            >
              <div className="menu-close d-lg-none">
                <Link to="">
                  {" "}
                  <i className="ri-close-line" />
                </Link>
              </div>
              <ul className="navbar-nav ms-auto">
                {/* <li className="nav-item">
                  <Link to="/" className="nav-link active">
                    Home
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const filters = new FilterParams({
                        propertyType: 1,
                        vertical: 1,
                        featured: null,
                      });

                      navigate("/view-all-listing?tabID=384", {
                        state: {
                          filters: filters,
                        },
                      });
                    }}
                    className="nav-link"
                  >
                    Properties
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="#" className="nav-link">
                    Services
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/view-all-projects?city=${""}&cityID=${""}`, {
                        state: { flag: 2 },
                      });
                    }}
                    className="nav-link"
                  >
                    New Projects
                  </Link>
                </li>

                     {logindata && LoggedInUserID != null && (
                        <li className="nav-item">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();

                      if (logindata && LoggedInUserID != null) {
                        const filters = new FilterParams({
                          propertyType: 1,
                          vertical: 1,
                          featured: null,
                          my : userData?.UserID
                        });
                        navigate("/view-all-listing?tabID=384", {
                          state: {
                            filters: filters,
                          },
                        });
                      } else {
                        setOpenLogin(true);
                      }
                    }}
                    className="nav-link"
                  >
                    My Listings
                  </Link>
                </li>

                     )}
              

                <li className="nav-item">
                  <Link to="#" className="nav-link">
                    About
                  </Link>
                </li>
              </ul>
              <div className="others-options  md-none">
                <div className="header-btn">
                  <button
                    type="button"
                    className="btn style1"
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      handleNavigate();
                    }}
                  >
                    Post Property
                  </button>

                  {logindata && logindata?.partySr ? (
                    <div className="btn style3">
                      Welcome <strong>{LoggedInUserName}</strong>
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="btn style3 loginbtn"
                      onClick={() => setOpenLogin(true)}
                    >
                      Login
                    </button>
                  )}
                </div>
              </div>
            </div>
          </nav>
          <div className="mobile-bar-wrap">
            <div className="mobile-menu d-lg-none">
              <Link to="javascript:void(0)">
                <i className="ri-menu-line" />
              </Link>
            </div>
          </div>
        </div>
      </header>

      <LoginDialog
        open={openLogin}
        onClose={() => setOpenLogin(false)}
        onSuccess={(data) => {
          if (data) {
            //  console.log("Login Success:", data);
            setLogindata(data);
            setlogindata(data);

            localStorage.setItem("loginData", JSON.stringify(data));
          }

          //  setUser(data);
        }}
        onUserDetails={(userDetails) => {
          if (userDetails) {
            // console.log("User Details:", userDetails);
            setUserdata(userDetails);
            setuserData(userDetails);
            localStorage.setItem("UserData", JSON.stringify(userDetails));
          }
        }}
      />
    </>
  );
}

export default Header;
